'use strict';

var Params = function Params(fixedBarWidth) {
  return function (containerWidth, containerHeight) {
    /*
     Unfortunately params have to adjusted by trial and error method,
     but those below get us the result we need
     */

    var padding = {
      top: 10,
      bottom: 60,
      left: 60,
      right: 15
    };
    var barWidth = 85;
    var width = fixedBarWidth * barWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      xAxisShift: 0,
      yAxisShift: 10,
      yAxisLabelShift: 45,
      xAxisLabelShift: -50,
      forceWidth: true
    };
  };
};
module.exports = Params;